module.exports = __webpack_public_path__ + "src/img/fabu_on.3be55807.svg";